<template>
  <div class="app">
    <router-view />
    <error />
    <Consent />
    <Clarify />
    <Kvkk />
  </div>
</template>

<script>
import Error from './components/ModalAlerts/ErrorModal.vue'
import Consent from './components/ModalAlerts/ConsentModal.vue'
import Clarify from './components/ModalAlerts/ClarifyModal.vue'
import Kvkk from './components/ModalAlerts/KvkkModal.vue'

export default {
  name: 'app',
  components: { Error, Consent, Clarify, Kvkk },
}
</script>

<style>
.app {
  width: 100%;
  height: 100%;
  font-family: BryantPro;
  font-size: 17px;
}
body { margin: 0 !important; }

@font-face {
    font-family: BryantPro;
    src: url(./assets/fonts/BryantPro-Regular.otf);
    font-weight: regular;
}

@font-face {
    font-family: BryantPro;
    src: url(./assets/fonts/BryantPro-Bold.otf);
    font-weight: bold;
}

@font-face {
font-family: BryantProBold;
src: url(./assets/fonts/BryantPro-Bold.otf);
}

@font-face {
font-family: PlakaFont;
src: url(./assets/fonts/D-DINCondensed-Bold.otf);
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>
